import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthLayout as Layout } from '../layouts'
import { useStateValue } from '../../providers'
import { authenticateUser, registerUser } from 'actions/api'
import { getValidateInvite } from 'actions/api'
import {
  Button,
  Card,
  Center,
  Icon,
  Logo,
  Link,
  FormInput,
  ThemeChooser,
  Title,
  Wrapper
} from '../../components'

export const Signup = () => {
  const [{ session }, dispatch] = useStateValue()
  const [state, setState] = useState({})
  const [inviteStatus, setInviteStatus] = useState('checking')
  const [error, setError] = useState(null)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const invite = params.get('invite')
    const email = params.get('email')
    if (!invite) {
      setInviteStatus('missing')
      return
    }
    getValidateInvite(invite).then((res) => {
      if (res?.valid) {
        setState((prev) => ({ ...prev, invite_code: invite, email: email || res.email }))
        setInviteStatus('valid')
      } else {
        setInviteStatus('invalid')
      }
    })
  }, [])

  const handler = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value })
  }

  const submit = async () => {
    setError(null)
    const signupResult = await registerUser(state)
    if (signupResult?.error) return setError(signupResult.error)
    const loginResult = await authenticateUser({ email: state.email, password: state.password })
    if (loginResult?.user) {
      dispatch({ type: 'LOGIN', data: loginResult })
    } else {
      setError('Account created — please log in.')
      navigate('/login')
    }
  }

  useEffect(() => {
    if (session.user) {
      const from = location.state?.from?.pathname || '/'
      navigate(from, { replace: true })
    }
  }, [session])

  const handleKeyDown = ({ key }) => {
    if (key === 'Enter') {
      submit()
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown, { passive: true })
    return () => window.removeEventListener('keydown', handleKeyDown, { passive: true })
  }, [state])

  if (inviteStatus === 'checking') return null

  if (inviteStatus === 'missing' || inviteStatus === 'invalid') {
    return (
      <Layout>
        <Card>
          <Wrapper margin="4rem 0">
            <Center>
              <Logo width="250" height="250" />
            </Center>
          </Wrapper>
          <Wrapper margin="0.5rem">
            <Title level={3} color="link">Signup is invite-only</Title>
          </Wrapper>
          <Wrapper margin="0.5rem">
            {inviteStatus === 'invalid'
              ? 'This invite link is no longer valid.'
              : 'You need an invite to create an account.'}
          </Wrapper>
          <Wrapper margin="0.5rem">
            <Link to="/beta">Join the waitlist</Link>
          </Wrapper>
        </Card>
      </Layout>
    )
  }

  return (
    <Layout>
      <Card>
        <Wrapper margin="4rem 0">
          <Center>
            <Logo width="250" height="250" />
          </Center>
        </Wrapper>
        <Wrapper margin="0.5rem">
          <Title level={3} color="link">
            Sign up!
          </Title>
        </Wrapper>
        <FormInput
          label="Full Name"
          name="full_name"
          onChange={handler}
          value={state.full_name}
        />
        <FormInput
          label="Email"
          name="email"
          onChange={handler}
          value={state.email}
          readonly={true}
        />
        <FormInput
          cleanSuffix="eye"
          label="Password"
          name="password"
          secure="true"
          value={state.password}
          onChange={handler}
        />
        <Button className="large" onPress={submit}>
          Create Account
        </Button>
        <Wrapper margin="0.5rem">
          <Link to="/login">login</Link>
        </Wrapper>
      </Card>
    </Layout>
  )
}
